import { useEffect, useRef } from 'react';
import { useAuth } from '../../../components/contexts/AuthContext';
import { useSocket } from '../../../components/contexts/SocketContext';
import { api } from '../models/attendance';
import { attendanceNotice, markAttendanceNoticeRead } from '../models/notifications';
export function useAttendanceNotifications(actions, enabled) {
  const { socket } = useSocket(), { authState } = useAuth(), callback = useRef(actions);
  const identity = `${authState?.id}:${authState?.token}:${authState?.session_id}`;
  useEffect(() => { callback.current = actions; });
  useEffect(() => {
    if (!socket || !enabled || !authState?.isAuthenticated) return undefined;
    const seen = new Set(); let current = true;
    const received = payload => {
      const row = payload?.notification, notice = attendanceNotice(row);
      if (!notice || seen.has(row.id)) return;
      seen.add(row.id); if (seen.size > 200) seen.delete(seen.values().next().value);
      callback.current.show({ key: notice.key, message: notice.title, description: notice.body, duration: 10, onClick: async () => {
        if (!current) return;
        try { await markAttendanceNoticeRead(row.id); } catch (_) { if (current) callback.current.error('Could not mark the notification read.'); }
        if (!current) return;
        let route = notice.route;
        if (notice.own) {
          try { const items = await api.reviews(); if (items.find(item => item.id === row.entity_id)?.kind === 'correction_request') route = '/settings/attendance/my-attendance?tab=corrections'; } catch (_) { /* The authorized own screen remains available to refresh. */ }
        }
        if (current) { callback.current.dismiss(notice.key); callback.current.navigate(route, notice.month ? { state: { attendanceMonth: notice.month } } : undefined); }
      } });
    };
    socket.on('notifications:new', received);
    return () => { current = false; socket.off('notifications:new', received); seen.forEach(id => callback.current.dismiss(`attendance:${id}`)); };
  }, [socket, enabled, identity, authState?.isAuthenticated]);
}
